class MathUtility {

	/**
	 * Resolve index notation to float number
	 * @param significand
	 * @param exponent
	 */
	resolveIndexNotation(significand, exponent) {
		return this.round(significand * Math.pow(10, exponent), 7);
	}

	round(number, precision) {
		let precisionMultiplicative = Math.pow(10, precision);

		return Math.round(number * precisionMultiplicative) / precisionMultiplicative;
	}
}

export default (new MathUtility);